import type { ReactNode } from 'react';

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="tablet:px-8 tablet:py-8 desktop:px-16 desktop:py-12 min-h-screen px-4 py-6">
      <main className="mx-auto max-w-450">{children}</main>
    </div>
  );
}
